import { MldEcommerceEventNames, MldEcommerceEventParams } from './ecommerceEvent'
import { CartProductItem, ProductItem } from '../../types'
import {
  formatCartItemsToEcommerce,
  formatProductItemsToEcommerce,
  getTotalPriceByCart,
} from '../../utils'

export const isCartEvent = (eventName: MldEcommerceEventNames) =>
  (
    ['begin_checkout', 'purchase', 'remove_from_cart', 'view_cart'] as Array<MldEcommerceEventNames>
  ).includes(eventName)

export const getTotalPrice = ({ eventName, products, parameters }: MldEcommerceEventParams) => {
  if (parameters?.value) {
    return parameters.value
  }

  if (isCartEvent(eventName)) {
    return getTotalPriceByCart(products as CartProductItem[])
  }

  return products.reduce((acc, item) => {
    const priceValue =
      (item as ProductItem).salePrice || (item as ProductItem).discountPrice || item.price
    const price = priceValue ? Number(priceValue) : 0
    const quantity = item.quantity ? Number(item.quantity) : 1
    return acc + price * quantity
  }, 0)
}

export const formatProducts = ({ eventName, products, parameters }: MldEcommerceEventParams) => {
  if (isCartEvent(eventName)) {
    return formatCartItemsToEcommerce(products as CartProductItem[], parameters)
  }

  return formatProductItemsToEcommerce(products as ProductItem[], parameters)
}
